export interface ServerMessage {
  message: string;
  httpStatus: number;
}
